<template>
  <div class="slider fl">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, index) in imgData" :key="index">
        <a @click="handleOp(item)"
          ><img class="slider-img" :src="item.coverFileUrl"
        /></a>
        <div class="slider-text" :title="item.title">{{ item.title }}</div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { getArgs } from "@/basa/utils";
// import { updateHits } from "@/app/shop/api/shopping";
export default {
  name: "slideShow",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        // loop: true,
        // //设定初始化时slide的索引
        // initialSlide: 0,
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false, //loop模式下无效
          disableOnInteraction: false
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        //滑动速度
        speed: 300,
        // //滑动方向
        // direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}" onmouseover="this.click()"></span>`;
          }
        }
      }
    };
  },
  methods: {
    handleOp(item) {
      //点击量
      // updateHits({
      //   publicityContentId: item.publicityContentId
      // });
      // if (item.otherUrl) {
      //   window.open(item.otherUrl);
      // }
      const idsStr = getArgs("ids");
      if (idsStr) {
        if (!item.id) return;
        this.$router.push({
          path: "/announcementDetail",
          query: {
            id: item.id,
            source: "0",
            publishedBy: item.publishedBy,
            ids: idsStr
          }
        });
      } else {
        this.$router.push({
          path: "/announcementDetail",
          query: {
            id: item.id,
            source: "0",
            publishedBy: item.publishedBy
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.slider {
  width: 624px;
  height: 438px;
  background: #ffffff;
  .slider-img {
    width: 100%;
    height: 370px;
  }
  .slider-text {
    font-weight: bold;
    font-size: 20px;
    color: #4a4a4a;
    line-height: 30px;
    text-align: center;
    font-style: normal;
    width: 624px;
    height: 35px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/deep/ .swiper-pagination {
  position: absolute;
  bottom: 35px;
  display: flex;
  justify-content: flex-end;
  transform: translate(-25px, -10px);
}
/deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}
/deep/ .swiper-pagination-bullet-active {
  background-color: #ffffff;
}
.fl {
  float: left;
}
.swiper-wrapper {
  transition-timing-function: linear !important;
}
</style>
